   
<template>
  <div class="messages pb-1">
    <div v-if="lowerRangeReults && !noReults">
      <div class="frame p-3 bg-light m-3">
        <p class="mb-0">
          {{hebrew ? 'קיימים אזכורים ברמת דיוק נמוכה יותר' : 'There are results at a lower accuracy level.'}}
        </p>
        <small>
          {{hebrew ? 'לצפייה באזכורים שנה את רמת הדיוק בסליידר המופיע בצד שמאל למעלה' : 'Adjust the Accuracy slider on the top right of the screen to view citations.'}}
        </small>
      </div>
    </div>
    <div v-else-if="higherRangeReults && !noReults">
      <div class="frame p-3 bg-light m-3">
        <p class="mb-0">
          {{hebrew ? 'קיימים אזכורים ברמת דיוק גבוהה יותר' : 'There are results at a higher accuracy level.'}}
        </p>
        <small>
          {{hebrew ? 'לצפייה באזכורים שנה את רמת הדיוק בסליידר המופיע בצד שמאל למעלה' : 'Adjust the Accuracy slider on the top right of the screen to view citations.'}}
        </small>
      </div>
    </div>
    <div v-else-if="noReults">
      <div v-if="tanakhResults.length">
        <div class="frame p-3 bg-light m-3">
          <p
            class="mb-2"
            v-if="tanakhResults.length == 1">
            {{hebrew ? 'קיים פסוק אחד בתנ"ך המכיל את המילים שחיפשת' : 'There is a verse in the Bible containing the words in your search query.'}}
          </p>
          <p
            class="mb-2"
            v-else
            v-html="hebrew ? 'קיימים '+tanakhResults.length+' פסוקים בתנ״ך שמכילים את המילים שחיפשת' : 
            'There are '+tanakhResults.length+' verses in the Bible containing the words in your search query.'"
          ></p>
          <a href="#" @click="switchMode(0)">
            <span class="border-bottom border-primary mx-1">{{hebrew ? 'חפש בתנ״ך' : 'Use the Bible search engine'}}</span>
            <small>
              <i v-if="hebrew" class="fa fa-arrow-left" aria-hidden="true"></i>
              <i v-else class="fa fa-arrow-right" aria-hidden="true"></i>
            </small>
          </a>
        </div>
      </div>
      <div v-if="mishnaResults.length">
        <div class="frame p-3 bg-light m-3">
          <p
            class="mb-2"
            v-if="mishnaResults.length == 1">
            {{hebrew ? 'קיים משנה המכיל את המילים שחיפשת' : 'There is a Mishnah that contains the words in your search query.'}}
          </p>
          <p
            class="mb-2"
            v-else
            v-html="hebrew ? 'קיימים '+mishnaResults.length+' משניות המכילות את המילים שחיפשת' : 
            'There are '+mishnaResults.length+' verses in the Mishna containing the words you searched'"
          ></p>
          <a href="#" @click="switchMode(2)">
            <span class="border-bottom border-primary mx-1">{{hebrew ? 'חפש במשנה' : 'Search the Mishnah'}}</span>
            <small>
              <i v-if="hebrew" class="fa fa-arrow-left" aria-hidden="true"></i>
              <i v-else class="fa fa-arrow-right" aria-hidden="true"></i>
            </small>
          </a>
        </div>
      </div>
      <div v-if="talmudResults.length">
        <div class="frame p-3 bg-light m-3">
          <p
            class="mb-2"
            v-if="talmudResults.length == 1">
            {{hebrew ? 'קיימת פסקה אחת בתלמוד המכילה את המילים שחיפשת' : 'There is a paragraph in the Talmud containing the words you searched'}}
          </p>
          <p
            class="mb-2"
            v-else
            v-html="hebrew ? 'קיימים '+talmudResults.length+' פסקאות בתלמוד שמכילים את המילים שחיפשת' : 
            'There are '+talmudResults.length+' paragraphs in the Talmud containing the words you searched'"
          ></p>
          <a href="#" @click="switchMode(1)">
            <span class="border-bottom border-primary mx-1">
              {{hebrew ? 'חפש בתלמוד' : 'Use the Talmud Search engine'}}
            </span>
            <small>
              <i v-if="hebrew" class="fa fa-arrow-left" aria-hidden="true"></i>
              <i v-else class="fa fa-arrow-right" aria-hidden="true"></i>
            </small>
          </a>
        </div>
      </div>
      <div v-if="!talmudResults.length && !mishnaResults.length && !tanakhResults.length">
        <p class="p-3">{{hebrew ? 'לא נמצאו תוצאות' : 'No results found'}}</p>
        <div class="frame p-3 bg-light m-3" v-if="extTanakhResultsNum > 0">
          <p
            class="mb-2"
            v-if="extTanakhResultsNum > 1"
            v-html="hebrew ? 'נמצאו '+extTanakhResultsNum+' פסוקים בתנ״ך שמכילים את המילים שחיפשת' : 
            'There are '+extTanakhResultsNum+' verses in the Bible containing the words in your search query.'"
          ></p>
          <p class="mb-2" v-if="extTanakhResultsNum == 1">
            {{hebrew ? 'קיים פסוק אחד בתנ"ך שמכיל את המילה שחיפשת' : 'There is a verse in the Bible containing the words in your search query. '}}</p>
          <a     
            target="_blank"
            :href="hebrew ? 'https://search.dicta.org.il/result?text='+ returnText : 'https://search.dicta.org.il/result?text='+returnText+'&lang=en'"
          >
            <span class="border-bottom border-primary mx-1">{{hebrew ? 'חפש במנוע החיפוש בתנ״ך' : 'Use the Bible search Engine'}}</span>
            <small>
              <i v-if="hebrew" class="fa fa-arrow-left" aria-hidden="true"></i>
              <i v-else class="fa fa-arrow-right" aria-hidden="true"></i>
            </small>
          </a>
        </div>
        <div class="frame p-3 bg-light m-3" v-if="extTalmudResultsNum > 0">
          <p
            class="mb-2"
            v-if="extTalmudResultsNum > 1"
            v-html="hebrew ? 'קיימים '+extTalmudResultsNum+' פסקאות בתלמוד שמכילים את המילים שחיפשת' : 
            'There are '+extTalmudResultsNum+' paragraphs in the Talmud containing the words you searched'"
          ></p>
          <p class="mb-2" v-if="extTalmudResultsNum == 1">
            {{hebrew ? 'קיימת פסקה אחת בתלמוד שמכילה את המילים שחיפשת' : 'There is a paragraph in the Talmud containing the words you searched'}}
          </p>
          <a target="_blank"
            :href=" hebrew ? 'https://talmudsearch.dicta.org.il/result?text='+returnText : 'https://talmudsearch.dicta.org.il/result?text='+returnText+'&lang=en'"
          >
            <span class="border-bottom border-primary mx-1">
              {{hebrew ? 'חפש במנוע החיפוש בתלמוד' : 'Use the Talmud Search Engine'}}
            </span>
            <small>
              <i v-if="hebrew" class="fa fa-arrow-left" aria-hidden="true"></i>
              <i v-else class="fa fa-arrow-right" aria-hidden="true"></i>
            </small>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Actions } from "@/store/stateChanges";
export default {
  name: "Messages",
  data() {
    return {
      returnText: this.$store.state.textForApiCall
    }
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },    
    noReults: function() {
      return this.$store.state.noResults;
    },
    extTalmudResultsNum: function() {
      return this.$store.state.extTalmudRes;
    },
    extTanakhResultsNum: function() {
      return this.$store.state.extTanakhRes;
    },
    lowerRangeReults: function() {
      return this.$store.state.lowerResults;
    },
    higherRangeReults: function() {
      return this.$store.state.higherResults;
    },
    talmudResults: function() {
      return this.$store.state.talmudResults;
    },
    mishnaResults: function() {
      return this.$store.state.mishnaResults;
    },
    tanakhResults: function() {
      return this.$store.state.tanakhResults;
    },
    currentMode: function() {
      return this.$store.state.mode;
    }
  },
  methods: {
    switchMode(mode) {
      this.$store.commit("SET_MODE", mode);
      switch (mode) {
        case 0:
          this.$store.commit("SET_VISUALIZER_MODE", ["tanakh"]);
          break;
        case 1:
          this.$store.commit("SET_VISUALIZER_MODE", ["talmud"]);
          break;
        case 2:
          this.$store.commit("SET_VISUALIZER_MODE", ["mishna"]);
          break;
      }
      this.$store.dispatch(Actions.RUN_PARSE);
    }
  }
};
</script>
<style scoped>
.messages {
  text-align: left;
  direction: ltr;
}
.he .messages {
  text-align: right;
  direction: rtl;
}
a:hover {
  text-decoration: none;
}
</style>